
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reorder",
      function () {
        return require("private-next-pages/reorder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reorder"])
      });
    }
  